import {JournalRecord} from '../entities/journalRecord'
import {supabase} from './BackendService'
import dayjs from 'dayjs'

// export type PlantEvent = {
//   id: number
//   plantId: number
//   name: string
//   comment: string
//   creationDateUtc?: Date
//   startDateUTC: Date
//   endDateUTC?: Date
//   type?: EventTypeId
//   photos?: string[]
// }

export class PlantEventsJournalService {
  public async deleteAllPlantEventsForPlant(currentPlantId: number) {
    const userId = (await supabase.auth.getSession()).data.session.user.id
    const photosList = await supabase.storage.from('photos').list(userId, {
      limit: 100,
      offset: 0,
      sortBy: {column: 'name', order: 'asc'},
    })
    let removingPhotosList = []
    if (!photosList.error) {
      removingPhotosList = photosList.data.map((photo) =>
        photo.name.startsWith(`${currentPlantId}-`) ? `${userId}/${photo.name}` : null
      )
    }
    const storagePhotoRemovingResult = await supabase.storage
      .from('photos')
      .remove(removingPhotosList)
    const {data, error} = await supabase
      .from('journalEvents')
      .delete()
      .eq('plantId', currentPlantId)
    if (error) {
      return {success: false, error}
    } else {
      return {success: true}
    }
  }

  public async addPlantEventPhotos(plantPhoto: any[], userId: string, plantId: number) {
    const errors = [] as Error[]
    const photosNames = [] as string[]

    if (plantPhoto.length != 0) {
      for (let photo of plantPhoto) {
        const name = plantId.toString() + '-' + Date.now().toString()
        photosNames.push(name)
        const {data, error} = await supabase.storage
          .from('photos')
          .upload(userId + '/' + name, photo.originFileObj, {
            cacheControl: '3600',
            upsert: false,
          })
        if (error) {
          errors.push(error)
        }
      }
    }

    if (errors.length !== 0) {
      return {success: false, errors}
    } else {
      return {success: true, photos: photosNames}
    }
  }

  public async deletePlantEventPhotos(plantPhoto: string[], userId: string, plantId: number) {
    const {data, error} = await supabase.storage
      .from('photos')
      .remove(plantPhoto.map((photo, index) => userId + '/' + photo))

    if (error) {
      return {success: false, error}
    } else {
      return {success: true}
    }
  }

  public async getPlantEventImageURLs(plantEventPhotoNames: string[] = []) {
    if (plantEventPhotoNames?.length === 0) {
      return {success: true, urls: []}
    }
    const userId = (await supabase.auth.getSession()).data.session.user.id
    const {data, error} = await supabase.storage.from('photos').createSignedUrls(
      plantEventPhotoNames?.map((photoName) => `${userId}/${photoName}`),
      60
    )

    if (error) {
      return {success: false, error}
    } else {
      return {success: true, urls: data.map((element) => element.signedUrl)}
    }
  }
}

export const instance = new PlantEventsJournalService()
